const TRANSLATIONS = {
  en: {
    titles: {
      dashboard: "Sensor Dashboard",
      leaf: "Disease Detection",
      satellite: "Satellite Analysis",
      consultant: "Smart Assistant",
      crops: "Crop Consultant",
      yield: "Yield Predictor",
      advanced_ai: "Advanced AI",
      accounting: "Farm Accounting",
      pesticide: "Pesticide Advisor",
      irrigation: "Smart Irrigation"
    },
    common: {
      logout: "Logout",
      agritech: "GeoNutria AI",
      slogan: "AI-Powered Smart Agriculture Platform",
      switchLang: "Switch to Arabic",
      aiDiagnosis: "AI General Diagnosis",
      export: "Export Report",
      exportDesc: "Generate a comprehensive PDF report of your farm's data.",
      farmName: "Farm Name",
      reporterName: "Reporter Name",
      selectFarm: "-- Select Farm --",
      selectCrop: "-- Select Crop --",
      selectTree: "-- Select Tree --",
      yourProfile: "YOUR PROFILE",
      units: {
        percent: "%",
        celsius: "\u00b0C",
        mg_kg: "mg/kg",
        mS_cm: "mS/cm",
        mg_L: "mg/L",
        mm: "mm",
        km_h: "km/h",
        W_m2: "W/m\u00b2"
      }
    },
    exportModal: {
      reportLang: "Report Language",
      previewBtn: "Preview Report",
      closePreview: "Close Preview",
      includedSections: "Included Sections (Auto-disabled if no data generated yet)",
      iot: "IoT Sensor Readings",
      leaf: "Leaf Disease Detection",
      soil: "Soil Type Detection",
      crop: "Crop Recommendation",
      yield: "Yield Estimator",
      satellite: "Satellite Imagery",
      consultant: "AI Consultant",
      downloadBtn: "Download Report",
      statusSat: "Downloading Satellite Images (Max 5s)...",
      statusAssemble: "Translating & Assembling Data...",
      statusGen: "Generating PDF (Backend processing)...",
      weather: "Live Weather",
      history: "Historical Readings",
      deviceMap: "Device Satellite Map",
      advancedAi: "Advanced AI Consultant",
      accounting: "Farm Accounting",
      control: "Control & Automation",
      previewTitle: "Report Document Preview",
      statusImages: "Preparing images…",
      statusTranslate: "Translating AI output…",
      previewFailed: "Preview Failed",
      exportFailed: "Export Failed",
      defaultFarmName: "Smart Farm",
      defaultReporter: "Admin",
      noDataYet: "No data generated yet",
      sizeWarning: "Some images were omitted to keep the report under the size limit."
    },
    login: {
      title: "AI-Powered Agriculture",
      btn: "Access Farm Control",
      placeholderUser: "Username",
      placeholderPass: "Password",
      loading: "Authenticating..."
    },
    dashboard: {
      thingsboardTitle: "Live Device Dashboard",
      liveStatus: "Live Farm Status",
      refresh: "Refresh Data",
      modelInsights: "AI Model Insights",
      featureDesc: "Environmental factors impacting health predictions.",
      healthy: "Healthy",
      stress: "Stress Detected",
      soilM: "Soil Moisture",
      soilT: "Soil Temp",
      ambT: "Ambient Temp",
      hum: "Humidity",
      ph: "Soil pH",
      nitrogen: "Nitrogen (N)",
      phosphorus: "Phosphorus (P)",
      potassium: "Potassium (K)",
      ec: "EC Signal",
      light: "Light Intensity",
      unit_mg: "mg/kg",
      mS_cm: "mS/cm",
      importance: "Importance",
      chlorophyll: "Chlorophyll",
      salinity: "Salinity (NaCl)",
      tds: "TDS (Total Dissolved Solids)",
      epsilon: "Epsilon (Dielectric Permittivity)",
      sensorDisconnected: 'The "{sensor}" sensor isn\'t connected to your farm'
    },
    iot: {
      connecting: "Connecting to Farm IoT Gateway...",
      unlockTitle: "Unlock the Power of Real-Time Farming",
      getHardware: "Get IoT Hardware",
      askSensors: "Ask About Sensors",
      syncRequired: "Live IoT Synchronization Required",
      syncDesc: "Your digital farm is waiting. Connect your first gateway or use Manual Entry to run AI simulations.",
      initScan: "Initialize Scan",
      telemetryOffline: "Live telemetry offline. Switching to manual simulation.",
      liveConnect: "Live Connect",
      manualEntry: "Manual Entry",
      selectDevice: "-- Select a Device --",
      syncNow: "Sync Now",
      processing: "Processing...",
      runAnalysis: "Run Analysis",
      hardwareIntegrationReq: "Hardware Integration Required",
      noRegisteredSensors: "You currently have no registered sensor devices. Integrate our smart IoT nodes to monitor crop health, soil metrics, and weather conditions in real-time.",
      awaitingNodeSelection: "Awaiting Node Selection",
      selectNodeDesc: "Please select a farm and a device from the top menu to view its live telemetry.",
      awaitingNode: "Awaiting Node",
      runDeepAnalysis: "Run Deep Analysis",
      scanning: "Scanning...",
      diagnosticsResult: "Diagnostics Result",
      conf: "Conf",
      macroWeather: "Macro Weather Data",
      resolvingLoc: "Resolving Location...",
      locationNone: "Location Not Selected",
      awaitingNode: "Awaiting Node Selection",
      historicalTelem: "Historical Telemetry",
      timeSeries: "Time Series",
      scanningArray: "Scanning Array...",
      noHistory: "No history",
      ambientTemp: "Ambient Temp",
      rainfall: "Rainfall",
      cloudCover: "Cloud Cover",
      windSpeed: "Wind Speed",
      solarRad: "Solar Rad",
      macroChartTitle: "Macro Weather Charts",
      macroChartSub: "Historical + Forecast",
      historical: "Historical",
      forecast: "Forecast",
      shadedForecast: "Shaded = Forecast",
      nowLabel: "Now",
      selectDeviceChart: "Select a device to view weather charts.",
      fetchingWeather: "Fetching weather data\u2026",
      noWeatherYet: "No weather data yet for this device.",
      noWeatherDesc: "Data populates after the first IoT sync cycle. Forecast data will appear once device GPS coordinates are saved.",
      weatherFooter: "Historical: device sensor DB \u00b7 Forecast: Open-Meteo API (max ~14 days)",
      liveRaw: "Live (Raw)",
      hours: "Hours",
      days: "Days",
      weeks: "Weeks",
      months: "Months",
      years: "Years",
      satelliteMatrix: "Satellite Device Matrix",
      noDeviceLocation: "No active device location coordinates available"
    },
    crops: {
      title: "Crop Recommendation Engine",
      step1: "Step 1: Soil Analysis",
      uploadLabel: "Choose File",
      noFile: "No file chosen",
      detectBtn: "Detect Soil Type",
      detected: "Detected Soil Type",
      scanning: "Scanning Soil Structure...",
      step2: "Step 2: Farm Data",
      autoFill: "Auto-Fill Sensors",
      waterLabel: "Water Availability",
      waterOptions: {
        low: "Scarcity / Rainfed (Low)",
        mod: "Moderate Irrigation",
        high: "Abundant Water Source",
        flood: "Heavy Rainfall / Flooded"
      },
      inputs: {
        temp: "Temp",
        n: "N",
        p: "P",
        k: "K",
        hum: "Hum",
        ph: "Ph"
      },
      btn: "Get Recommendations",
      results: "Results will appear here",
      confidence: "Match",
      soil_types: {
        "Alluvial soil": "Alluvial soil", "Black Soil": "Black Soil", "Clay soil": "Clay soil",
        "Red soil": "Red soil"
      },
      crop_names: {
        "rice": "Rice", "maize": "Maize", "chickpea": "Chickpea", "kidneybeans": "Kidney Beans",
        "pigeonpeas": "Pigeon Peas", "mothbeans": "Moth Beans", "mungbean": "Mung Bean",
        "blackgram": "Black Gram", "lentil": "Lentil", "pomegranate": "Pomegranate",
        "banana": "Banana", "mango": "Mango", "grapes": "Grapes", "watermelon": "Watermelon",
        "muskmelon": "Muskmelon", "apple": "Apple", "orange": "Orange", "papaya": "Papaya",
        "coconut": "Coconut", "cotton": "Cotton", "jute": "Jute", "coffee": "Coffee"
      }
    },
    leaf: {
      uploadTitle: "Leaf Doctor",
      dropText: "Upload leaf image for analysis",
      btnAnalyze: "Start Diagnosis",
      btnReset: "Analyze Another Leaf",
      analyzing: "Analyzing Leaf Pattern...",
      diagnosis: "Diagnosis Result",
      confidence: "Confidence",
      imageLoaded: "Image loaded successfully. Ready to analyze.",
      cancel: "Cancel",
      plantType: "Plant Type",
      typeGeneral: "General Leaf",
      typePalm: "Palm Tree",
      noLeaves: "AI didn't see any leaves. Try uploading more images in different angles or light conditions.",
      processing: "Processing...",
      pending: "Waiting...",
      diseases: {
        'Tomato___Late_blight': 'Tomato Late Blight',
        'Tomato___healthy': 'Tomato Healthy',
        'Grape___healthy': 'Grape Healthy',
        'Orange___Haunglongbing_(Citrus_greening)': 'Orange Citrus Greening',
        'Soybean___healthy': 'Soybean Healthy',
        'Squash___Powdery_mildew': 'Squash Powdery Mildew',
        'Potato___healthy': 'Potato Healthy',
        'Corn_(maize)___Northern_Leaf_Blight': 'Corn Northern Leaf Blight',
        'Tomato___Early_blight': 'Tomato Early Blight',
        'Tomato___Septoria_leaf_spot': 'Tomato Septoria Leaf Spot',
        'Corn_(maize)___Cercospora_leaf_spot Gray_leaf_spot': 'Corn Gray Leaf Spot',
        'Strawberry___Leaf_scorch': 'Strawberry Leaf Scorch',
        'Peach___healthy': 'Peach Healthy',
        'Apple___Apple_scab': 'Apple Scab',
        'Tomato___Tomato_Yellow_Leaf_Curl_Virus': 'Tomato Yellow Leaf Curl Virus',
        'Tomato___Bacterial_spot': 'Tomato Bacterial Spot',
        'Apple___Black_rot': 'Apple Black Rot',
        'Blueberry___healthy': 'Blueberry Healthy',
        'Cherry_(including_sour)___Powdery_mildew': 'Cherry Powdery Mildew',
        'Peach___Bacterial_spot': 'Peach Bacterial Spot',
        'Apple___Cedar_apple_rust': 'Apple Cedar Rust',
        'Tomato___Target_Spot': 'Tomato Target Spot',
        'Pepper,_bell___healthy': 'Pepper Bell Healthy',
        'Grape___Leaf_blight_(Isariopsis_Leaf_Spot)': 'Grape Leaf Blight',
        'Potato___Late_blight': 'Potato Late Blight',
        'Tomato___Tomato_mosaic_virus': 'Tomato Mosaic Virus',
        'Strawberry___healthy': 'Strawberry Healthy',
        'Apple___healthy': 'Apple Healthy',
        'Grape___Black_rot': 'Grape Black Rot',
        'Potato___Early_blight': 'Potato Early Blight',
        'Cherry_(including_sour)___healthy': 'Cherry Healthy',
        'Corn_(maize)___Common_rust_': 'Corn Common Rust',
        'Grape___Esca_(Black_Measles)': 'Grape Esca (Black Measles)',
        'Raspberry___healthy': 'Raspberry Healthy',
        'Tomato___Leaf_Mold': 'Tomato Leaf Mold',
        'Tomato___Spider_mites Two-spotted_spider_mite': 'Tomato Spider Mites',
        'Pepper,_bell___Bacterial_spot': 'Pepper Bacterial Spot',
        'Corn_(maize)___healthy': 'Corn Healthy',
        'Brown_Spots': 'Brown Spots',
        'White_Scale': 'White Scale',
        'False_Smut': 'False Smut',
        'Leaf_Spots': 'Leaf Spots'
      }
    },
    satellite: {
      analysisMode: "Analysis Mode",
      modeIndices: "Soil & Crop Indices",
      modeCount: "Aerial Palm Counting",
      uploadAerial: "Upload Aerial Images",
      palmsDetected: "Palms Detected",
      title: "Satellite Farm Analysis",
      getLocation: "To get my location click here",
      drawPoly: "Select area on map and run analysis.",
      resetPoly: "Reset Area",
      radius: "Analysis Radius (km)",
      km: "km",
      area: "Analyzed Area",
      sqkm: "km²",
      run: "Run Satellite Analysis",
      loading: "Fetching & Analysing Satellite Imagery...",
      compareTitle: "Compare Past Amount",
      timeUnit: "Time Unit",
      unitWeeks: "Weeks Ago",
      unitMonths: "Months Ago",
      unitYears: "Years Ago",
      startDate: "Start Date",
      endDate: "End Date",
      currentInsight: "Current Insight",
      pastInsight: "Past Insight",
      avg: "Satellite Indicator Average",
      visual: "Visual Overview (RGB)",
      indicesTitle: "Detailed Soil & Crop Indices",
      ndvi: "NDVI General Plant Health",
      ndmi: "NDMI Crop Moisture Level",
      ndwi: "NDWI Soil Moisture Indicator",
      ndre: "NDRE Nitrogen / Fertilization Indicator",
      gndvi: "GNDVI Plant Greenness Vigor",
      savi: "SAVI Sparse Crop Health",
      no_data: "No valid data",
      ndvi_low: "Barren rock/sand",
      ndvi_mod: "Sparse vegetation",
      ndvi_high: "Moderate vegetation (Healthy)",
      ndvi_vhigh: "Dense vegetation (Very Healthy)",
      ndmi_low: "Water stress detected (Dry)",
      ndmi_mod: "Moderate water content",
      ndmi_high: "High water content (No Stress)",
      ndwi_flood: "Water body detected",
      ndwi_wet: "High soil moisture",
      ndwi_dry: "Dry soil / Drought conditions",
      ndre_low: "Low Nitrogen/Stressed",
      ndre_high: "Optimal Nitrogen levels",
      gndvi_low: "Low vigor",
      gndvi_mod: "Moderate vigor",
      gndvi_high: "High vigor",
      savi_arid: "Desert/Arid soil",
      savi_growth: "Germination/Early growth",
      savi_canopy: "Full Canopy"
    },
    consultant: {
      title: "AI Consultant",
      loadingTitle: "AI Consultant Thinking",
      subtitle: "Connected to Farm Sensors",
      startBtn: "Analyze Life & Sensors",
      placeholder: "Ask follow up question...",
      send: "Send",
      contextLeaf: "Leaf Data Attached",
      intro: "I have access to your soil sensors, latest leaf scan, and weather data. Click below to generate a comprehensive diagnosis.",
      loading: "Consulting AI Models...",
      analyzing: "ANALYZING FARM SENSORS...",
      connecting: "Connecting to your farm's data",
      processing: "Processing...",
      commandCenter: "AI Command Center",
      commandDesc: "Select the specific data points you want the AI to analyze and correlate.",
      customizedAnalysis: "Customized Consultant Analysis",
      includeUserInfo: "Include User Info",
      macroWeatherData: "Macro Weather Data",
      deviceData: "Device Data",
      none: "None",
      leafDoctor: "Leaf Doctor",
      soilAnalysis: "Soil Analysis",
      cropRec: "Crop Recommendation",
      cropYield: "Crop Yield Estimator",
      satelliteAnalysis: "Satellite Analysis",
      aerialPalms: "Aerial Palms Count"
    },
    yield: {
      title: "Crop Yield Estimator",
      subtitle: "AI Regression Model",
      yieldSubtitle: "Estimate total crop harvest volume (kg/acre) utilizing environmental ML analytics.",
      config: "Configuration",
      env: "Soil & Environment",
      ready: "Ready to Predict",
      readyDesc: "Select crop, water level, and sensor data to generate an estimate",
      autoFill: "Auto-Fill Sensors",
      predictBtn: "Calculate Expected Yield",
      resultTitle: "Predicted Output",
      unit: "kg/acre",
      basedOn: "Based on",
      inputs: {
        crop: "Select Crop Type",
        water: "Water Availability (Rainfall)",
        n: "Nitrogen (N)",
        p: "Phosphorus (P)",
        k: "Potassium (K)",
        temp: "Temperature (°C)",
        hum: "Humidity (%)",
        ph: "Soil pH"
      },
      crops: {
        rice: "Rice",
        maize: "Maize",
        chickpea: "Chickpea",
        cotton: "Cotton"
      },
      waterOptions: {
        low: "Low / Scarcity",
        medLow: "Below Average",
        mod: "Moderate / Irrigated",
        high: "High / Abundant"
      }
    },

    // ─── Sidebar Navigation Labels ───────────────────────────────────────
    nav: {
      billing: "Billing",
      admin: "Admin Panel",
      navSection: "Navigation"
    },

    // ─── Top Header Labels ────────────────────────────────────────────────
    header: {
      aiCredits: "AI Credits",
      topUp: "⚡ Top Up",
      topUpEmpty: "⚡ Top Up (0)",
      helpTooltip: "How to use this page",
      refresh: "Refresh Credits"
    },

    // ─── Extended Login View Strings (split-screen redesign) ─────────────
    login_ext: {
      welcomeBack: "Welcome back",
      signInSubtitle: "Sign in to your GeoNutria account",
      dontHaveAccount: "Don't have an account?",
      signUp: "Sign Up",
      orContinueWith: "or continue with",
      continueGoogle: "Continue with Google",
      otpSentTo: "OTP sent to",
      otpHint: "Enter the 6-digit code from your email.",
      verifyBtn: "Verify & Activate Account",
      verifying: "Verifying\u2026",
      brandTitle: "Smart Agriculture",
      brandTitleAccent: "Powered by AI",
      brandSubtitle: "AI-driven crop intelligence, satellite NDVI analysis, IoT sensor fusion, and precision irrigation \u2014 all in one platform.",
      brandFooter: "\u00a9 2025 GeoNutria \u00b7 Precision Farming Intelligence"
    },

    // ─── Login Feature Pills ──────────────────────────────────────────────
    featurePills: {
      ai: "AI Modeling",
      irrigation: "Smart Irrigation",
      crop: "Crop Health",
      yield: "Yield Prediction"
    },

    // ─── New AI Chat Translations ─────────────────────────────────────────
    new_ai: {
      title: "Advanced AI Consultant",
      subtitle: "Professional Agricultural Engineer",
      exportCompliance: "Export Compliance",
      exportComplianceDesc: "Enhance crop quality and yield quantity to strictly comply with the European export code.",
      deepDiagnosis: "Deep Diagnosis",
      deepDiagnosisDesc: "Run a separate, deep-dive diagnosis of a specific issue, disease, or problem within the farm.",
      placeholder: "Describe your farm's condition or ask a question...",
      send: "Send Message",
      stop: "Stop Response",
      newChat: "New Chat",
      thinking: "Thinking Process",
      thinkingLive: "Reasoning…",
      uploadImage: "Upload Image",
      uploadFile: "Attach File",
      imageUploaded: "Image ready",
      fileAttached: "File attached",
      online: "Model Online",
      offline: "Model Offline",
      error: "Error occurred",
      dropImage: "Drop image here or click to upload",
      pastedImage: "Pasted image",
      chatHistory: "Chat History",
      noHistory: "No previous chats",
      today: "Today",
      earlier: "Earlier",
      welcomeTitle: "Welcome to GeoNutria AI",
      welcomeDesc: "Your professional agriculture consultant. Ask anything about crops, irrigation, diseases, or farm management."
    },

    // ─── Global Context Bar ───────────────────────────────────────────────
    globalContext: {
      sectionTitle: "Farm Context",
      collapse: "Hide Context",
      expand: "Show Farm Context",
      cropType: "Crop Type",
      cropVariety: "Crop Variety",
      location: "Geographic Location",
      season: "Current Season",
      irrigationType: "Irrigation Type",
      waterQuantity: "Water Quantity",
      waterUnit: "m³/Feddan/Week",
      soilType: "Soil Type",
      analysisDepth: "Analysis Response Depth",
      searchPlaceholder: "Search or enter custom...",
      selectPlaceholder: "Select...",
      noResults: "No results found. Type to create.",
      clearSelection: "Clear",
      defaultAssumptions: "Note: Analysis is based on default assumptions: ",
      analysisDepthOptions: {
        executive: "Quick Executive Summary",
        standard: "Standard Technical Plan",
        comprehensive: "Comprehensive In-Depth Audit"
      },
      // Crop Types
      crops: {
        wheat: "Wheat",
        rice: "Rice",
        maize: "Maize",
        cotton: "Cotton",
        sugarcane: "Sugarcane",
        berseem: "Clover (Berseem)",
        citrus: "Citrus",
        tomatoes: "Tomatoes",
        potatoes: "Potatoes",
        sugarBeet: "Sugar Beet",
        strawberries: "Strawberries",
        pomegranates: "Pomegranates",
        dates: "Dates / Palm",
        onions: "Onions",
        beans: "Beans / Fava",
        grapes: "Grapes",
        mangoes: "Mangoes"
      },
      // Crop Varieties (keyed by crop)
      varieties: {
        wheat: { giza171: "Giza 171", sids14: "Sids 14", misr3: "Misr 3", sakha95: "Sakha 95", giza168: "Giza 168", shandaweel1: "Shandaweel 1", beniSuef7: "Beni Suef 7", sids13: "Sids 13", misr2: "Misr 2", giza171_2: "Gemmiza 12" },
        rice: { giza178: "Giza 178", giza177: "Giza 177", sakha101: "Sakha 101", sakha104: "Sakha 104", sakha108: "Sakha 108", giza179: "Giza 179", hybrid1: "Hybrid 1 Egyptian", sakha106: "Sakha 106", giza182: "Giza 182", yasmine: "Egyptian Yasmine" },
        maize: { sc168: "SC 168 (Single Cross)", sc10: "SC 10", twc368: "TWC 368 (Three-Way)", sc122: "SC 122", sc131: "SC 131", sc162: "SC 162", twc310: "TWC 310", sc124: "SC 124", sc166: "SC 166", giza2: "Giza 2" },
        cotton: { giza94: "Giza 94", giza96: "Giza 96", giza97: "Giza 97", giza95: "Giza 95", giza92: "Giza 92", giza90: "Giza 90", giza86: "Giza 86", giza88: "Giza 88", giza93: "Giza 93", giza80: "Giza 80" },
        sugarcane: { gt5464: "GT 54/64", ph8013: "PH 80/13", c918: "C 9/18", g8437: "G 84/37", g9953: "G 99/53", g8447: "G 84/47", g200376: "G 2003/76", g200347: "G 2003/47", eg48: "EG 48", eg61: "EG 61" },
        berseem: { helaly: "Helaly (Multi-cut)", meskawy: "Meskawy", saidy: "Saidy", serw1: "Serw 1", giza6: "Giza 6", sakha4: "Sakha 4", gemmiza1: "Gemmiza 1", fahl: "Fahl (Single-cut)", khadrawi: "Khadrawi", giza5: "Giza 5" },
        citrus: { washingtonNavel: "Washington Navel", valencia: "Valencia", balady: "Balady (Lime)", mandarin: "Balady Mandarin", clementine: "Clementine", murcott: "Murcott", eureka: "Eureka Lemon", adalia: "Adalia Lemon", grapefruitMarsh: "Marsh Grapefruit", bloodOrange: "Blood Orange", fremont: "Fremont", starRuby: "Star Ruby" },
        tomatoes: { superStrain: "Super Strain B", castleRock: "Castle Rock", gs12: "GS 12", claudia: "Claudia", carmen: "Carmen", alissa: "Alissa", jana: "Jana", codaRound: "Coda Round", flora: "Flora", niagara: "Niagara" },
        potatoes: { spunta: "Spunta", diamant: "Diamant", hermes: "Hermes", cara: "Cara", desiree: "Desiree", lady_rosetta: "Lady Rosetta", nicola: "Nicola", burren: "Burren", valorA: "Valor", bellini: "Bellini" },
        sugarBeet: { kawmira: "Kawmira", top: "Top", helios: "Helios", pleno: "Pleno", oscar_poly: "Oscar Poly", gloria: "Gloria", rasoul: "Rasoul", lp15: "LP-15", farida: "Farida", monte_bianco: "Monte Bianco" },
        strawberries: { fortuna: "Fortuna", festival: "Festival", sensation: "Sensation", floridaBeauty: "Florida Beauty" },
        pomegranates: { manfalouti: "Manfalouti", wonderful: "Wonderful", baladi: "Baladi" },
        dates: { siwi: "Siwi", zaghloul: "Zaghloul", hayani: "Hayani", barhi: "Barhi", majhoul: "Majhoul" },
        onions: { giza6White: "Giza 6 White", giza20Red: "Giza 20 Red", redAmposta: "Red Amposta" },
        beans: { giza843: "Giza 843 Fava", giza716: "Giza 716 Fava", bronco: "Bronco Green Beans" },
        grapes: { superiorSeedless: "Superior Seedless", flameSeedless: "Flame Seedless", thompson: "Thompson", crimson: "Crimson" },
        mangoes: { keitt: "Keitt", kent: "Kent", owais: "Owais", zebda: "Zebda", alphons: "Alphons" }
      },
      // Locations
      locations: {
        upperEgypt: "Upper Egypt",
        lowerEgypt: "Lower Egypt (Delta)",
        canalZone: "Canal Zone",
        sinai: "Sinai",
        newValley: "New Valley & Oases"
      },
      // Seasons
      seasons: {
        winter: "Winter",
        spring: "Spring",
        summer: "Summer",
        autumn: "Autumn"
      },
      // Irrigation Types
      irrigationTypes: {
        drip: "Drip Irrigation",
        sprinkler: "Sprinkler Irrigation",
        flood: "Surface / Flood Irrigation",
        pivot: "Center Pivot"
      },
      // Soil Types
      soilTypes: {
        clay: "Clay Soil",
        sandy: "Sandy Soil",
        calcareous: "Calcareous Soil",
        saline: "Saline Soil",
        silty: "Silty Soil"
      }
    },

    // ─── RAG Diagnostics Panel ────────────────────────────────────────────
    diagnostics: {
      title: "AI Deep Diagnostics",
      statusHealthy: "Normal — No Stress",
      statusStress: "Stress Detected",
      statusAnalyzing: "Analyzing...",
      summaryTitle: "Summary Diagnosis",
      factorsTitle: "Key Contributing Factors",
      recommendationsTitle: "Actionable Recommendations",
      poweredBy: "Powered by GeoNutria's AI-powered RAG System",
      collapse: "Collapse",
      expand: "Expand Details",
      newAnalysis: "Run New Analysis",
      liveStreaming: "Live Analysis",
      analysisComplete: "Analysis Complete",
      errorTitle: "Analysis Failed",
      errorDesc: "Could not connect to the AI diagnostic service. Please try again.",
      retryBtn: "Retry Analysis",
      thinkingLive: "Reasoning…",
      thinkingDone: "Thinking Process"
    },
    control: {
      title: "Farm Control & Automation",
      manualControl: "Manual Control",
      aiAutomation: "AI Smart Scheduling",
      generateSchedule: "Generate Smart Schedule",
      generating: "Generating schedule…",
      applySchedule: "Apply Schedule",
      applyAll: "Apply All Rules",
      activeSchedules: "Active Schedules",
      noSchedules: "No automation schedules yet.",
      pumpOn: "ON",
      pumpOff: "OFF",
      brightness: "Brightness",
      colorPicker: "Color Picker",
      noActuators: "No control devices assigned to your account. Contact your administrator to get started.",
      commandSent: "Command sent successfully",
      commandFailed: "Failed to send command",
      scheduleApplied: "Schedule applied successfully",
      allSchedulesApplied: "All AI rules applied successfully",
      aiExplanation: "AI Reasoning",
      triggerType: "Trigger Type",
      cronSchedule: "Scheduled (Cron)",
      thresholdTrigger: "Threshold Trigger",
      aiSuggested: "AI Suggested",
      duration: "Duration (min)",
      active: "Active",
      inactive: "Inactive",
      deviceName: "Device Name",
      deviceType: "Device Type",
      mqttPubTopic: "MQTT Publish Topic",
      mqttSubTopic: "MQTT Subscribe Topic",
      assignedTo: "Assigned To",
      farm: "Farm",
      state: "State",
      actions: "Actions",
      addActuator: "Add Actuator",
      editActuator: "Edit Actuator",
      deleteConfirm: "Are you sure you want to delete this actuator?",
      pump: "Pump",
      led: "LED",
      rgb: "RGB Light",
      valve: "Valve",
      fan: "Fan",
      other: "Other",
      scheduleName: "Schedule Name",
      cronExpression: "Cron Expression",
      thresholdSensor: "Sensor",
      thresholdOperator: "Operator",
      thresholdValue: "Value",
      actionType: "Action",
      connected: "Connected",
      disconnected: "Disconnected",
      lastUpdate: "Last Update",
      manualOverride: "Manual Override",
      smartScheduleDesc: "Let AI analyze your sensor data, weather forecast, and crop needs to generate optimal automation rules.",
      noDeviceData: "No sensor data available for scheduling.",
      createSchedule: "Create Schedule",
      editSchedule: "Edit Schedule",
      ruleName: "Rule Name",
      ruleNamePlaceholder: "e.g. Morning Watering",
      targetActuator: "Target Actuator",
      selectActuator: "Select Actuator",
      sensorTrigger: "Sensor Trigger",
      timeSchedule: "Time Schedule",
      sourceDevice: "Source Device",
      selectDevice: "Select Device",
      threshold: "Threshold",
      operator: "Operator",
      metric: "Metric",
      selectMetric: "Select Metric",
      executionProfile: "Execution Profile",
      runDuration: "Run Duration (mins)",
      action: "Action",
      turnOn: "Turn ON",
      turnOff: "Turn OFF",
      saveSchedule: "Save Rule",
      newRule: "+ New Rule",
      frequencyOnce: "Once",
      frequencyRecurring: "Recurring",
      selectDays: "Select Days",
      selectDate: "Select Date",
      selectTime: "Select Time",
      dayMon: "Mon",
      dayTue: "Tue",
      dayWed: "Wed",
      dayThu: "Thu",
      dayFri: "Fri",
      daySat: "Sat",
      daySun: "Sun",
      hour: "Hour",
      minute: "Minute"
    },
    admin: {
      commandCenter: "Admin Command Center",
      commandCenterDesc: "Manage users, payments, and global sensor networks.",
      tabs: {
        overview: "Overview",
        users: "User Management",
        iot: "Device Fleet",
        actuators: "Actuators",
        approvals: "Billing Approvals"
      },
      common: {
        refresh: "Refresh",
        actions: "Actions",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit"
      },
      overview: {
        totalUsers: "Total Users",
        revenue: "Total Revenue",
        totalAiRuns: "Total AI Runs"
      },
      users: {
        name: "Name",
        email: "Email",
        role: "Role",
        aiCredits: "AI Credits",
        verified: "Verified",
        joined: "Joined"
      },
      iotMap: {
        loadingMap: "Loading global fleet map..."
      },
      actuators: {
        title: "System Actuators",
        registerNew: "Register New Actuator",
        cancel: "Cancel",
        loading: "Loading actuators...",
        noActuators: "No actuators found.",
        deleteConfirm: "Are you sure you want to delete this actuator?",
        deleteSuccess: "Actuator deleted successfully.",
        createSuccess: "Actuator registered successfully!",
        createFail: "Failed to create actuator",
        selectUserAlert: "Please select an assigned user.",
        form: {
          actuatorName: "Actuator Name",
          actuatorNamePlaceholder: "e.g. Main Field Pump A",
          controlCategory: "Control Category",
          publishTopic: "MQTT Publish Topic (Commands)",
          publishTopicPlaceholder: "farm/pump_a/cmd",
          subscribeTopic: "MQTT Subscribe Topic (Feedback)",
          subscribeTopicPlaceholder: "farm/pump_a/state",
          assignUser: "Assign to User",
          selectUser: "-- Select User --"
        },
        location: {
          mapPicker: "Map Picker",
          manualEntry: "Manual Entry",
          mapInstruction: "Click on the map to set the actuator's location.",
          lat: "Latitude",
          lng: "Longitude",
          locName: "Location Name",
          locNamePlaceholder: "e.g. Zone A",
          notSet: "Not set"
        },
        table: {
          id: "ID",
          name: "Device Name",
          type: "Type",
          pubTopic: "Publish Topic",
          location: "Location",
          users: "Users"
        }
      }
    },

    // ─── Farm Accounting Module ──────────────────────────────────────────
    accounting: {
      tabTitle: "Farm Accounting",
      netProfit: "Net Profit",
      revenues: "Revenues",
      expenses: "Expenses",
      yearLabel: "Fiscal Year",
      addNode: "Add Item",
      addChild: "Add Sub-item",
      deleteNode: "Delete",
      deleteConfirm: "Delete this item and all its sub-items?",
      confirmYes: "Yes, Delete",
      confirmNo: "Cancel",
      totalAmount: "Total Amount",
      unitPrice: "Unit Price",
      quantity: "Quantity",
      frequency: "Frequency",
      categoryName: "Category Name",
      categoryPlaceholder: "Search or type a category...",
      addNewCategory: "Add \"{name}\" as new category",
      noCategories: "No matching categories",
      saving: "Saving...",
      saved: "Saved",
      saveError: "Save failed",
      currency: "EGP",
      currencySymbol: "£E",
      positive: "Profit",
      negative: "Loss",
      breakeven: "Break Even",
      expandDetails: "Show Details",
      collapseDetails: "Hide Details",
      emptyTree: "Start building your financial tree",
      emptyTreeDesc: "Add revenue and expense items to track your farm's profitability.",
      backToApp: "Back",
      // Frequency options
      freq_daily: "Daily",
      freq_weekly: "Weekly",
      freq_monthly: "Monthly",
      freq_seasonally: "Seasonally",
      freq_yearly: "Yearly",
      // AI Advisor
      aiAdvisor: "AI Financial Advisor",
      aiAdvisorDesc: "Get AI-powered insights on your farm's finances",
      aiAnalyze: "Analyze My Farm",
      aiAnalyzing: "Analyzing...",
      aiLength: "Report Length",
      aiShort: "Short (~100 words)",
      aiMedium: "Medium (~200 words)",
      aiFull: "Full Report",
      aiEmpty: "Add some financial data first to get AI insights.",
      aiError: "AI analysis failed. Please try again."
    }
  },
  ar: {
    titles: {
      dashboard: "مراقبة الحساسات",
      leaf: "كشف الأمراض",
      satellite: "تحليل الأقمار الصناعية",
      consultant: "المساعد الذكي",
      crops: "مستشار المحاصيل",
      yield: "توقعات الحصاد",
      advanced_ai: "الذكاء المتقدم",
      accounting: "حسابات المزرعة",
      pesticide: "استشاري المبيدات",
      irrigation: "الري الذكي"
    },
    common: {
      logout: "تسجيل الخروج",
      agritech: "الزراعة الذكية",
      slogan: "الزراعة الذكية المدعومة بالذكاء الاصطناعي",
      switchLang: "التحويل للإنجليزية",
      aiDiagnosis: "التشخيص العام للذكاء الاصطناعي",
      export: "أستخراج التقرير",
      exportDesc: "إنشاء تقرير PDF شامل لبيانات مزرعتك.",
      farmName: "اسم المزرعة",
      reporterName: "اسم المُعِد",
      selectFarm: "-- اختر المزرعة --",
      selectCrop: "-- اختر المحصول --",
      selectTree: "-- اختر الشجرة --",
      yourProfile: "ملفك الشخصي",
      units: {
        percent: "%",
        celsius: "\u00b0C",
        mg_kg: "ملجم/كجم",
        mS_cm: "ميكرو سيمنز/سم",
        mg_L: "ملجم/لتر",
        mm: "ملم",
        km_h: "كم/س",
        W_m2: "واط/م\u00b2"
      }
    },
    exportModal: {
      reportLang: "لغة التقرير",
      includedSections: "الأقسام المضمنة (تُعطل تلقائياً إذا لم تتوفر بيانات)",
      previewBtn: "معاينة التقرير",
      closePreview: "إغلاق المعاينة",
      iot: "قراءات الحساسات (IoT)",
      leaf: "كشف أمراض النباتات",
      soil: "تحديد نوع التربة",
      crop: "توصيات المحاصيل",
      yield: "توقع الحصاد",
      satellite: "صور الأقمار الصناعية",
      consultant: "المستشار الذكي",
      downloadBtn: "تحميل التقرير",
      statusSat: "جاري جلب صور الأقمار الصناعية (5 ثوان كحد أقصى)...",
      statusAssemble: "جاري تجميع وترجمة البيانات...",
      statusGen: "جاري إنشاء التقرير ...",
      weather: "الطقس المباشر",
      history: "القراءات التاريخية",
      deviceMap: "خريطة الأجهزة بالأقمار الصناعية",
      advancedAi: "المستشار الذكي المتقدم",
      accounting: "حسابات المزرعة",
      control: "التحكم والأتمتة",
      previewTitle: "معاينة مستند التقرير",
      statusImages: "جاري تجهيز الصور…",
      statusTranslate: "جاري ترجمة مخرجات الذكاء الاصطناعي…",
      previewFailed: "فشلت المعاينة",
      exportFailed: "فشل التصدير",
      defaultFarmName: "مزرعة ذكية",
      defaultReporter: "مدير النظام",
      noDataYet: "لا توجد بيانات بعد",
      sizeWarning: "تم استبعاد بعض الصور للحفاظ على حجم التقرير ضمن الحد المسموح."
    },
    login: {
      title: "الزراعة المدعومة بالذكاء الاصطناعي",
      btn: "دخول النظام",
      placeholderUser: "اسم المستخدم",
      placeholderPass: "كلمة المرور",
      loading: "جار تسجيل الدخول..."
    },
    dashboard: {
      liveStatus: "حالة المزرعة الحية",
      refresh: "تحديث البيانات",
      modelInsights: "تحليلات الذكاء الاصطناعي",
      featureDesc: "العوامل البيئية المؤثرة على التنبؤ الصحي.",
      healthy: "صحة جيدة",
      stress: "يوجد إجهاد",
      soilM: "رطوبة التربة",
      soilT: "حرارة التربة",
      ambT: "حرارة الجو",
      hum: "الرطوبة الجوية",
      ph: "حموضة التربة",
      nitrogen: "سماد النيتروجين",
      phosphorus: "سماد الفسفور",
      potassium: "سماد البوتاسيوم",
      ec: "التوصيل الكهربي",
      light: "الإضاءة",
      chlorophyll: "الكلوروفيل",
      unit_mg: "ملجم/كجم",
      mS_cm: "ميكرو سيمنز/سم",
      thingsboardTitle: "لوحة تحكم الأجهزة الحية",
      importance: "الأهمية",
      salinity: "ملوحة التربة",
      tds: "الأملاح المذابة الكلية (TDS)",
      epsilon: "سماحية العزل (Epsilon)",
      sensorDisconnected: 'حساس "{sensor}" غير متصل بمزرعتك'
    },
    iot: {
      connecting: "جارٍ الاتصال ببوابة المزرعة الرقمية...",
      unlockTitle: "أطلق إمكانات الزراعة الذكية",
      getHardware: "احصل على أجهزة IoT",
      askSensors: "اسأل عن الحساسات",
      syncRequired: "مزامنة IoT الحية مطلوبة",
      syncDesc: "مزرعتك الرقمية في انتظارك. وصّل بوابتك الأولى أو استخدم الإدخال اليدوي.",
      initScan: "بدء المسح",
      telemetryOffline: "التتبع الحي غير متاح. تحويل للمحاكاة اليدوية.",
      liveConnect: "اتصال حي",
      manualEntry: "إدخال يدوي",
      selectDevice: "-- اختر جهازًا --",
      syncNow: "مزامنة الآن",
      processing: "جارٍ المعالجة...",
      runAnalysis: "تشغيل التحليل",
      hardwareIntegrationReq: "يلزم ربط أجهزة الاستشعار",
      noRegisteredSensors: "ليس لديك حالياً أي أجهزة استشعار مسجلة. قم بدمج أجهزتنا الذكية لمراقبة صحة المحاصيل، مؤشرات التربة، والظروف الجوية في الوقت الفعلي.",
      awaitingNodeSelection: "في انتظار اختيار الجهاز",
      selectNodeDesc: "الرجاء اختيار مزرعة وجهاز من القائمة العلوية لعرض بياناته الحية.",
      awaitingNode: "في انتظار الجهاز",
      runDeepAnalysis: "تحليل عميق",
      scanning: "جارٍ المسح...",
      diagnosticsResult: "نتيجة التشخيص",
      conf: "ثقة",
      macroWeather: "بيانات الطقس الكلي",
      resolvingLoc: "تحديد الموقع...",
      locationNone: "لم يُحدد موقع",
      awaitingNode: "في انتظار تحديد العقدة",
      historicalTelem: "البيانات التاريخية",
      timeSeries: "سلسلة زمنية",
      scanningArray: "مسح البيانات...",
      noHistory: "لا توجد بيانات",
      ambientTemp: "حرارة الجو",
      rainfall: "هطول الأمطار",
      cloudCover: "الغطاء السحابي",
      windSpeed: "سرعة الرياح",
      solarRad: "الإشعاع الشمسي",
      macroChartTitle: "مخططات الطقس الكلي",
      macroChartSub: "تاريخي + توقع",
      historical: "تاريخي",
      forecast: "توقع",
      shadedForecast: "المظلل = توقع",
      nowLabel: "الآن",
      selectDeviceChart: "اختر جهازًا لعرض مخططات الطقس.",
      fetchingWeather: "جارٍ جلب بيانات الطقس...",
      noWeatherYet: "لا توجد بيانات طقس لهذا الجهاز بعد.",
      noWeatherDesc: "تُملأ البيانات بعد دورة المزامنة الأولى. تظهر بيانات التوقع بعد حفظ إحداثيات الجهاز.",
      weatherFooter: "تاريخي: قاعدة بيانات الحساسات \u00b7 توقع: Open-Meteo API (حتى 14 يومًا)",
      liveRaw: "حي (\u062eام)",
      hours: "ساعات",
      days: "أيام",
      weeks: "أسابيع",
      months: "أشهر",
      years: "سنوات",
      satelliteMatrix: "خريطة أجهزة الاستشعار",
      noDeviceLocation: "لا توجد إحداثيات موقع لأجهزة نشطة"
    },
    crops: {
      title: "محرك توصيات المحاصيل",
      step1: "الخطوة 1: تحليل التربة",
      uploadLabel: "اختر ملف",
      noFile: "لم يتم اختيار ملف",
      detectBtn: "كشف نوع التربة",
      detected: "نوع التربة المكتشف",
      scanning: "جار مسح هيكل التربة...",
      step2: "الخطوة 2: بيانات المزرعة",
      autoFill: "تعبة تلقائية لبيانات الحساسات",
      waterLabel: "توفر المياه",
      waterOptions: {
        low: "نادرة / بعلية (قليل)",
        mod: "ري متوسط",
        high: "مصدر مياه وفير",
        flood: "أمطار غزيرة / غمر"
      },
      inputs: {
        n: "النيتروجين (N)",
        p: "الفسفور (P)",
        k: "البوتاسيوم (K)",
        temp: "الحرارة (°C)",
        hum: "الرطوبة (%)",
        ph: "الحموضة (pH)"
      },
      btn: "احصل على المحاصيل",
      results: "ستظهر النتائج هنا",
      confidence: "تطابق",
      soil_types: {
        "Alluvial soil": "تربة طينية", "Black Soil": "تربة سوداء", "Clay soil": "تربة صلصالية",
        "Red soil": "تربة حمراء"
      },
      crop_names: {
        "rice": "أرز", "maize": "ذرة", "chickpea": "حمص", "kidneybeans": "فاصولياء حمراء",
        "pigeonpeas": "بازلاء الحمام", "mothbeans": "لوبيا", "mungbean": "فول مونج",
        "blackgram": "عدس أسود", "lentil": "عدس", "pomegranate": "رمان",
        "banana": "موز", "mango": "مانجو", "grapes": "عنب", "watermelon": "بطيخ",
        "muskmelon": "شمام", "apple": "تفاح", "orange": "برتقال", "papaya": "بابايا",
        "coconut": "جوز هند", "cotton": "قطن", "jute": "جوت", "coffee": "قهوة"
      }
    },
    leaf: {
      uploadTitle: "طبيب النبات",
      plantType: "نوع النبات",
      typeGeneral: "نبات عام",
      typePalm: "نخيل",
      noLeaves: "لم يتعرف الذكاء الاصطناعي على أي أوراق. يرجى محاولة رفع صور أخرى بظروف إضاءة وزوايا مختلفة.",
      processing: "جاري المعالجة...",
      pending: "في الانتظار...",
      dropText: "ارفع صورة الورقة للتحليل",
      btnAnalyze: "بدء التشخيص",
      btnReset: "تحليل ورقة أخرى",
      analyzing: "جاري تحليل نمط الورقة...",
      diagnosis: "نتيجة التشخيص",
      confidence: "نسبة الثقة",
      imageLoaded: "تم تحميل الصورة بنجاح. جاهز للتحليل.",
      cancel: "إلغاء",
      diseases: {
        'Tomato___Late_blight': 'طماطم - اللفحة المتأخرة',
        'Tomato___healthy': 'طماطم - سليمة',
        'Grape___healthy': 'عنب - سليم',
        'Orange___Haunglongbing_(Citrus_greening)': 'برتقال - اخضرار الحمضيات',
        'Soybean___healthy': 'فول الصويا - سليم',
        'Squash___Powdery_mildew': 'كوسة - البياض الدقيقي',
        'Potato___healthy': 'بطاطس - سليمة',
        'Corn_(maize)___Northern_Leaf_Blight': 'ذرة - لفحة الأوراق الشمالية',
        'Tomato___Early_blight': 'طماطم - اللفحة المبكرة',
        'Tomato___Septoria_leaf_spot': 'طماطم - تبقع الأوراق السبتوري',
        'Corn_(maize)___Cercospora_leaf_spot Gray_leaf_spot': 'ذرة - تبقع الأوراق الرمادي',
        'Strawberry___Leaf_scorch': 'فراولة - احتراق الأوراق',
        'Peach___healthy': 'خوخ - سليم',
        'Apple___Apple_scab': 'تفاح - جرب التفاح',
        'Tomato___Tomato_Yellow_Leaf_Curl_Virus': 'طماطم - فيروس تجعد الأوراق الأصفر',
        'Tomato___Bacterial_spot': 'طماطم - التبقع البكتيري',
        'Apple___Black_rot': 'تفاح - العفن الأسود',
        'Blueberry___healthy': 'توت أزرق - سليم',
        'Cherry_(including_sour)___Powdery_mildew': 'كرز - البياض الدقيقي',
        'Peach___Bacterial_spot': 'خوخ - التبقع البكتيري',
        'Apple___Cedar_apple_rust': 'تفاح - صدأ الأرز',
        'Tomato___Target_Spot': 'طماطم - التبقع المستهدف',
        'Pepper,_bell___healthy': 'فلفل حلو - سليم',
        'Grape___Leaf_blight_(Isariopsis_Leaf_Spot)': 'عنب - لفحة الأوراق',
        'Potato___Late_blight': 'بطاطس - اللفحة المتأخرة',
        'Tomato___Tomato_mosaic_virus': 'طماطم - فيروس الموزاييك',
        'Strawberry___healthy': 'فراولة - سليمة',
        'Apple___healthy': 'تفاح - سليم',
        'Grape___Black_rot': 'عنب - العفن الأسود',
        'Potato___Early_blight': 'بطاطس - اللفحة المبكرة',
        'Cherry_(including_sour)___healthy': 'كرز - سليم',
        'Corn_(maize)___Common_rust_': 'ذرة - الصدأ الشائع',
        'Grape___Esca_(Black_Measles)': 'عنب - مرض إسكا (الحصبة السوداء)',
        'Raspberry___healthy': 'توت العليق - سليم',
        'Tomato___Leaf_Mold': 'طماطم - عفن الأوراق',
        'Tomato___Spider_mites Two-spotted_spider_mite': 'طماطم - سوس العنكبوت',
        'Pepper,_bell___Bacterial_spot': 'فلفل حلو - التبقع البكتيري',
        'Corn_(maize)___healthy': 'ذرة - سليمة',
        'Brown_Spots': 'تبقع بني',
        'White_Scale': 'الحشرة القشرية البيضاء',
        'False_Smut': 'التفحم الكاذب',
        'Leaf_Spots': 'تبقع الأوراق'
      }
    },
    consultant: {
      title: "المهندس الزراعي الذكي",
      subtitle: "متصل بالحساسات",
      startBtn: "تحليل الحياة والحساسات",
      placeholder: "اسأل سؤالاً...",
      send: "إرسال",
      contextLeaf: "تم إرفاق بيانات الورقة",
      intro: "لدي وصول إلى حساسات التربة، وفحص الورقة، وبيانات الطقس. اضغط أدناه لإنشاء تشخيص شامل.",
      loadingTitle: "المهندس الزراعي الذكي",
      loading: "جاري استشارة النماذج الذكية...",
      analyzing: "جار تحليل بيانات المزرعة...",
      connecting: "جاري الاتصال ببيانات مزرعتك...",
      processing: "جار المعالجة...",
      commandCenter: "مركز القيادة الذكي",
      commandDesc: "حدد نقاط البيانات التي تريد من الذكاء الاصطناعي تحليلها وربطها.",
      customizedAnalysis: "تحليل مستشار مخصص",
      includeUserInfo: "تضمين بيانات المستخدم",
      macroWeatherData: "بيانات الطقس الكلي",
      deviceData: "بيانات الجهاز",
      none: "لا شيء",
      leafDoctor: "طبيب الأوراق",
      soilAnalysis: "تحليل التربة",
      cropRec: "توصيات المحاصيل",
      cropYield: "تقدير الحصاد",
      satelliteAnalysis: "تحليل الأقمار الصناعية",
      aerialPalms: "عد النخيل الجوي"
    },
    satellite: {
      title: "تحليل المزرعة الفضائي",
      getLocation: "اضغط هنا لتحديد موقعي",
      drawPoly: "حدد المنطقة على الخريطة وشغل التحليل",
      resetPoly: "إلغاء الرسم",
      radius: "نصف القطر (كم)",
      km: "كم",
      area: "المساحة المحللة",
      sqkm: "كم²",
      run: "تشغيل التحليل الفضائي",
      loading: "جلب وتحليل صور الأقمار الصناعية...",
      compareTitle: "مقارنة بالماضي",
      timeUnit: "وحدة الزمن",
      unitWeeks: "أسابيع",
      unitMonths: "شهور",
      unitYears: "سنوات",
      startDate: "تاريخ البدء",
      endDate: "تاريخ الانتهاء",
      currentInsight: "الرؤية الحالية",
      pastInsight: "الرؤية السابقة",
      avg: "متوسط ​​مؤشر القمر الصناعي",
      visual: "نظرة بصرية (RGB)",
      indicesTitle: "مؤشرات التربة والمحاصيل التفصيلية",
      ndvi: "صحة النبات العامة",
      ndmi: "مستوى رطوبة المحصول",
      ndwi: "مؤشر ري التربة",
      ndre: "مؤشر النيتروجين / التسميد",
      gndvi: "حيوية واخضرار النبات",
      savi: "صحة المحاصيل المتناثرة",
      no_data: "لا توجد بيانات",
      ndvi_low: "صخور جرداء / رمال",
      ndvi_mod: "نباتات متناثرة",
      ndvi_high: "نباتات متوسطة (صحي)",
      ndvi_vhigh: "غطاء نباتي كثيف (صحي جداً)",
      ndmi_low: "إجهاد مائي (جاف)",
      ndmi_mod: "محتوى مائي متوسط",
      ndmi_high: "محتوى مائي عالي (لا يوجد إجهاد)",
      ndwi_flood: "رصد مسطحات مائية",
      ndwi_wet: "رطوبة تربة عالية",
      ndwi_dry: "تربة جافة / جفاف",
      ndre_low: "نيتروجين منخفض / إجهاد",
      ndre_high: "مستويات نيتروجين مثالية",
      gndvi_low: "حيوية منخفضة",
      gndvi_mod: "حيوية متوسطة",
      gndvi_high: "حيوية عالية",
      savi_arid: "تربة صحراوية / قاحلة",
      savi_growth: "إنبات / نمو مبكر",
      savi_canopy: "غطاء كامل",
      analysisMode: "نوع التحليل",
      modeIndices: "مؤشرات التربة والمحاصيل",
      modeCount: "العد الجوي للنخيل",
      uploadAerial: "رفع الصور الجوية",
      palmsDetected: "نخلة تم رصدها"
    },
    yield: {
      title: "محرك توقع الحصاد",
      subtitle: "نموذج الانحدار الذكي",
      yieldSubtitle: "تقدير إجمالي حجم محصول الحصاد (كجم/فدان) باستخدام تحليلات التعلم الآلي البيئية.",
      config: "الإعدادات",
      env: "التربة والبيئة",
      ready: "جاهز للتوقع",
      readyDesc: "اختر المحصول ومستوى المياه وبيانات الحساسات لإنشاء التقدير",
      autoFill: "تعبة تلقائية لبيانات الحساسات",
      predictBtn: "حساب التوقع",
      resultTitle: "الإنتاج المتوقع",
      unit: "كجم/فدان",
      basedOn: "بناءً على",
      inputs: {
        crop: "نوع المحصول",
        water: "توافر المياه (الأمطار)",
        n: "النيتروجين (N)",
        p: "الفسفور (P)",
        k: "البوتاسيوم (K)",
        temp: "الحرارة (°C)",
        hum: "الرطوبة (%)",
        ph: "الحموضة (pH)"
      },
      crops: {
        rice: "أرز",
        maize: "ذرة",
        chickpea: "حمص",
        cotton: "قطن"
      },
      waterOptions: {
        low: "منخفضة / شحيحة",
        medLow: "أقل من المتوسط",
        mod: "متوسطة / ري منتظم",
        high: "عالية / وفيرة"
      }
    },

    // ─── Sidebar Navigation Labels (AR) ──────────────────────────────────
    nav: {
      billing: "الفواتير",
      admin: "لوحة الإدارة",
      navSection: "التنقل"
    },

    // ─── Top Header Labels (AR) ───────────────────────────────────────────
    header: {
      aiCredits: "رصيد الذكاء",
      topUp: "\u26a1 شحن الرصيد",
      topUpEmpty: "\u26a1 الرصيد فارغ",
      helpTooltip: "كيفية استخدام هذه الصفحة",
      refresh: "تحديث الرصيد"
    },

    // ─── Extended Login View Strings (AR) ────────────────────────────────
    login_ext: {
      welcomeBack: "مرحباً بعودتك",
      signInSubtitle: "تسجيل الدخول إلى حساب جيونوتريا",
      dontHaveAccount: "ليس لديك حساب؟",
      signUp: "سجّل الآن",
      orContinueWith: "أو تابع مع",
      continueGoogle: "المتابعة عبر Google",
      otpSentTo: "تم إرسال الرمز إلى",
      otpHint: "أدخل الرمز المكون من 6 أرقام من بريدك الإلكتروني.",
      verifyBtn: "تحقق وتفعيل الحساب",
      verifying: "جاري التحقق...",
      brandTitle: "الزراعة الذكية",
      brandTitleAccent: "بالذكاء الاصطناعي",
      brandSubtitle: "ذكاء المحاصيل، تحليل الأقمار الصناعية، دمج حساسات الإنترنت، وري دقيق \u2014 كل ذلك في منصة واحدة.",
      brandFooter: "\u00a9 2025 جيونوتريا \u00b7 ذكاء الزراعة الدقيقة"
    },

    // ─── Login Feature Pills (AR) ─────────────────────────────────────────
    featurePills: {
      ai: "نمذجة ذكية",
      irrigation: "ري ذكي",
      crop: "صحة المحصول",
      yield: "توقع الحصاد"
    },

    // ─── New AI Chat Translations (AR) ────────────────────────────────────
    new_ai: {
      title: "المستشار الذكي المتقدم",
      subtitle: "مهندس زراعي محترف",
      exportCompliance: "التوافق مع التصدير",
      exportComplianceDesc: "تحسين جودة المحصول وكمية الحصاد ليتوافق بدقة مع كود التصدير الأوروبي.",
      deepDiagnosis: "تشخيص عميق",
      deepDiagnosisDesc: "إجراء تشخيص منفصل وعميق لمشكلة معينة أو مرض أو خلل داخل المزرعة.",
      placeholder: "صف حالة مزرعتك أو اطرح سؤالاً...",
      send: "إرسال رسالة",
      stop: "إيقاف الرد",
      newChat: "محادثة جديدة",
      thinking: "عملية التفكير",
      thinkingLive: "يفكر…",
      uploadImage: "رفع صورة",
      uploadFile: "إرفاق ملف",
      imageUploaded: "الصورة جاهزة",
      fileAttached: "تم إرفاق ملف",
      online: "النموذج متصل",
      offline: "النموذج غير متصل",
      error: "حدث خطأ",
      dropImage: "أسقط الصورة هنا أو انقر للرفع",
      pastedImage: "صورة ملصقة",
      chatHistory: "سجل المحادثات",
      noHistory: "لا توجد محادثات سابقة",
      today: "اليوم",
      earlier: "سابقاً",
      welcomeTitle: "مرحباً في جيونوتريا الذكية",
      welcomeDesc: "مستشارك الزراعي المحترف. اسأل عن أي شيء يخص المحاصيل والري والأمراض وإدارة المزرعة."
    },

    // ─── Global Context Bar (AR) ──────────────────────────────────────────
    globalContext: {
      sectionTitle: "سياق المزرعة",
      collapse: "إخفاء السياق",
      expand: "إظهار سياق المزرعة",
      cropType: "نوع المحصول",
      cropVariety: "صنف المحصول",
      location: "الموقع الجغرافي",
      season: "الموسم الحالي",
      irrigationType: "نوع الري",
      waterQuantity: "كمية المياه",
      waterUnit: "م³/فدان/أسبوع",
      soilType: "نوع التربة",
      analysisDepth: "عمق استجابة التحليل",
      searchPlaceholder: "بحث أو إدخال قيمة...",
      selectPlaceholder: "اختر...",
      noResults: "لا توجد نتائج. اكتب للإضافة.",
      clearSelection: "مسح",
      defaultAssumptions: "ملاحظة: يستند التحليل إلى الافتراضات الافتراضية: ",
      analysisDepthOptions: {
        executive: "موجز تنفيذي سريع",
        standard: "خطة فنية قياسية",
        comprehensive: "تقرير تحليلي شامل وتفصيلي"
      },
      crops: {
        wheat: "قمح",
        rice: "أرز",
        maize: "ذرة",
        cotton: "قطن",
        sugarcane: "قصب السكر",
        berseem: "برسيم",
        citrus: "موالح",
        tomatoes: "طماطم",
        potatoes: "بطاطس",
        sugarBeet: "بنجر السكر",
        strawberries: "فراولة",
        pomegranates: "رمان",
        dates: "بلح ونخيل",
        onions: "بصل",
        beans: "فاصوليا وفول",
        grapes: "عنب",
        mangoes: "مانجو"
      },
      varieties: {
        wheat: { giza171: "جيزة 171", sids14: "سدس 14", misr3: "مصر 3", sakha95: "سخا 95", giza168: "جيزة 168", shandaweel1: "شندويل 1", beniSuef7: "بني سويف 7", sids13: "سدس 13", misr2: "مصر 2", giza171_2: "جميزة 12" },
        rice: { giza178: "جيزة 178", giza177: "جيزة 177", sakha101: "سخا 101", sakha104: "سخا 104", sakha108: "سخا 108", giza179: "جيزة 179", hybrid1: "هجين 1 مصري", sakha106: "سخا 106", giza182: "جيزة 182", yasmine: "ياسمين مصري" },
        maize: { sc168: "هجين فردي 168", sc10: "هجين فردي 10", twc368: "هجين ثلاثي 368", sc122: "هجين فردي 122", sc131: "هجين فردي 131", sc162: "هجين فردي 162", twc310: "هجين ثلاثي 310", sc124: "هجين فردي 124", sc166: "هجين فردي 166", giza2: "جيزة 2" },
        cotton: { giza94: "جيزة 94", giza96: "جيزة 96", giza97: "جيزة 97", giza95: "جيزة 95", giza92: "جيزة 92", giza90: "جيزة 90", giza86: "جيزة 86", giza88: "جيزة 88", giza93: "جيزة 93", giza80: "جيزة 80" },
        sugarcane: { gt5464: "GT 54/64", ph8013: "PH 80/13", c918: "C 9/18", g8437: "G 84/37", g9953: "G 99/53", g8447: "G 84/47", g200376: "G 2003/76", g200347: "G 2003/47", eg48: "EG 48", eg61: "EG 61" },
        berseem: { helaly: "حلالي (متعدد الحشات)", meskawy: "مسقاوي", saidy: "صعيدي", serw1: "سرو 1", giza6: "جيزة 6", sakha4: "سخا 4", gemmiza1: "جميزة 1", fahl: "فحل (حشة واحدة)", khadrawi: "خضراوي", giza5: "جيزة 5" },
        citrus: { washingtonNavel: "واشنطن نافل", valencia: "فالنسيا", balady: "بلدي", mandarin: "يوسفي بلدي", clementine: "كلمنتينا", murcott: "موركوت", eureka: "يوريكا ليمون", adalia: "أضاليا ليمون", grapefruitMarsh: "جريب فروت مارش", bloodOrange: "برتقال دموي", fremont: "فريمونت", starRuby: "ستار روبي" },
        tomatoes: { superStrain: "سوبر سترين ب", castleRock: "كاسل روك", gs12: "GS 12", claudia: "كلوديا", carmen: "كارمن", alissa: "أليسا", jana: "جنى", codaRound: "كودا راوند", flora: "فلورا", niagara: "نياجرا" },
        potatoes: { spunta: "سبونتا", diamant: "ديامونت", hermes: "هيرمس", cara: "كارا", desiree: "ديزيريه", lady_rosetta: "ليدي روزيتا", nicola: "نيكولا", burren: "بورين", valorA: "فالور", bellini: "بيلليني" },
        sugarBeet: { kawmira: "كاوميرا", top: "توب", helios: "هيليوس", pleno: "بلينو", oscar_poly: "أوسكار بولي", gloria: "جلوريا", rasoul: "رسول", lp15: "LP-15", farida: "فريدة", monte_bianco: "مونتي بيانكو" },
        strawberries: { fortuna: "فورتونا", festival: "فيستفال", sensation: "سينسيشن", floridaBeauty: "فلوريدا بيوتي" },
        pomegranates: { manfalouti: "منفلوطي", wonderful: "وندرفول", baladi: "بلدي" },
        dates: { siwi: "سيوة", zaghloul: "زغلول", hayani: "حياني", barhi: "برحي", majhoul: "مجدول" },
        onions: { giza6White: "جيزة 6 أبيض", giza20Red: "جيزة 20 أحمر", redAmposta: "أحمر أامبوستا" },
        beans: { giza843: "فول جيزة 843", giza716: "فول جيزة 716", bronco: "فاصوليا برونكو" },
        grapes: { superiorSeedless: "سوبريو", flameSeedless: "فليم", thompson: "طومسون", crimson: "كريمسون" },
        mangoes: { keitt: "كيت", kent: "كينت", owais: "عويس", zebda: "زبدة", alphons: "الفونس" }
      },
      locations: {
        upperEgypt: "الصعيد",
        lowerEgypt: "الدلتا - وجه بحري",
        canalZone: "القناة",
        sinai: "سيناء",
        newValley: "الوادي الجديد والواحات"
      },
      seasons: {
        winter: "الشتاء",
        spring: "الربيع",
        summer: "الصيف",
        autumn: "الخريف"
      },
      irrigationTypes: {
        drip: "الري بالتنقيط",
        sprinkler: "الري بالرش",
        flood: "الري بالغمر",
        pivot: "الري المحوري"
      },
      soilTypes: {
        clay: "تربة طينية",
        sandy: "تربة رملية",
        calcareous: "تربة جيرية",
        saline: "تربة ملحية",
        silty: "تربة طميية"
      }
    },

    // ─── RAG Diagnostics Panel (AR) ───────────────────────────────────────
    diagnostics: {
      title: "التشخيص العميق بالذكاء الاصطناعي",
      statusHealthy: "طبيعي — لا يوجد إجهاد",
      statusStress: "تم اكتشاف إجهاد",
      statusAnalyzing: "جاري التحليل...",
      summaryTitle: "ملخص التشخيص",
      factorsTitle: "العوامل الرئيسية المؤثرة",
      recommendationsTitle: "التوصيات العملية",
      poweredBy: "نظام الذكاء الاصطناعي للتوليد المعزز بالاسترجاع الخاص بجيونيتريا",
      collapse: "طي",
      expand: "عرض التفاصيل",
      newAnalysis: "تشغيل تحليل جديد",
      liveStreaming: "تحليل مباشر",
      analysisComplete: "اكتمل التحليل",
      errorTitle: "فشل التحليل",
      errorDesc: "تعذر الاتصال بخدمة التشخيص الذكي. يرجى المحاولة مرة أخرى.",
      retryBtn: "إعادة المحاولة",
      thinkingLive: "جاري التفكير…",
      thinkingDone: "عملية التفكير"
    },
    control: {
      title: "التحكم والأتمتة في المزرعة",
      manualControl: "التحكم اليدوي",
      aiAutomation: "الجدولة الذكية بالذكاء الاصطناعي",
      generateSchedule: "إنشاء جدول ذكي",
      generating: "جاري إنشاء الجدول…",
      applySchedule: "تطبيق الجدول",
      applyAll: "تطبيق جميع القواعد",
      activeSchedules: "الجداول النشطة",
      noSchedules: "لا توجد جداول أتمتة بعد.",
      pumpOn: "تشغيل",
      pumpOff: "إيقاف",
      brightness: "السطوع",
      colorPicker: "اختيار اللون",
      noActuators: "لا توجد أجهزة تحكم مخصصة لحسابك. تواصل مع المسؤول للبدء.",
      commandSent: "تم إرسال الأمر بنجاح",
      commandFailed: "فشل إرسال الأمر",
      scheduleApplied: "تم تطبيق الجدول بنجاح",
      allSchedulesApplied: "تم تطبيق جميع قواعد الذكاء الاصطناعي بنجاح",
      aiExplanation: "تحليل الذكاء الاصطناعي",
      triggerType: "نوع المشغل",
      cronSchedule: "مجدول (Cron)",
      thresholdTrigger: "مشغل العتبة",
      aiSuggested: "مقترح من الذكاء الاصطناعي",
      duration: "المدة (دقيقة)",
      active: "نشط",
      inactive: "غير نشط",
      deviceName: "اسم الجهاز",
      deviceType: "نوع الجهاز",
      mqttPubTopic: "موضوع النشر MQTT",
      mqttSubTopic: "موضوع الاشتراك MQTT",
      assignedTo: "مخصص لـ",
      farm: "المزرعة",
      state: "الحالة",
      actions: "الإجراءات",
      addActuator: "إضافة جهاز تحكم",
      editActuator: "تعديل جهاز التحكم",
      deleteConfirm: "هل أنت متأكد من حذف جهاز التحكم هذا؟",
      pump: "مضخة",
      led: "مصباح LED",
      rgb: "إضاءة RGB",
      valve: "صمام",
      fan: "مروحة",
      other: "أخرى",
      scheduleName: "اسم الجدول",
      cronExpression: "تعبير Cron",
      thresholdSensor: "المستشعر",
      thresholdOperator: "المشغل",
      thresholdValue: "القيمة",
      actionType: "نوع الإجراء",
      connected: "متصل",
      disconnected: "غير متصل",
      lastUpdate: "آخر تحديث",
      manualOverride: "تحكم يدوي",
      smartScheduleDesc: "دع الذكاء الاصطناعي يحلل بيانات المستشعرات وتوقعات الطقس واحتياجات المحاصيل لإنشاء قواعد أتمتة مثالية.",
      noDeviceData: "لا توجد بيانات مستشعرات متاحة للجدولة.",
      createSchedule: "إنشاء جدول",
      editSchedule: "تعديل الجدول",
      ruleName: "اسم القاعدة",
      ruleNamePlaceholder: "مثل: ري صباحي",
      targetActuator: "جهاز التحكم المستهدف",
      selectActuator: "اختر جهاز التحكم",
      sensorTrigger: "مشغل المستشعر",
      timeSchedule: "جدول زمني",
      sourceDevice: "جهاز المصدر",
      selectDevice: "اختر الجهاز",
      threshold: "العتبة",
      operator: "المعامل",
      metric: "المقياس",
      selectMetric: "اختر المقياس",
      executionProfile: "ملف التنفيذ",
      runDuration: "مدة التشغيل (دقائق)",
      action: "الإجراء",
      turnOn: "تشغيل",
      turnOff: "إيقاف",
      saveSchedule: "حفظ القاعدة",
      newRule: "+ قاعدة جديدة",
      frequencyOnce: "مرة واحدة",
      frequencyRecurring: "متكرر",
      selectDays: "اختر الأيام",
      selectDate: "اختر التاريخ",
      selectTime: "اختر الوقت",
      dayMon: "الإثنين",
      dayTue: "الثلاثاء",
      dayWed: "الأربعاء",
      dayThu: "الخميس",
      dayFri: "الجمعة",
      daySat: "السبت",
      daySun: "الأحد",
      hour: "الساعة",
      minute: "الدقيقة"
    },
    admin: {
      commandCenter: "مركز إدارة النظام",
      commandCenterDesc: "إدارة المستخدمين، المدفوعات، وشبكات الحساسات العالمية.",
      tabs: {
        overview: "نظرة عامة",
        users: "إدارة المستخدمين",
        iot: "أسطول الأجهزة",
        actuators: "وحدات التحكم",
        approvals: "موافقات الفواتير"
      },
      common: {
        refresh: "تحديث",
        actions: "الإجراءات",
        save: "حفظ",
        cancel: "إلغاء",
        delete: "حذف",
        edit: "تعديل"
      },
      overview: {
        totalUsers: "إجمالي المستخدمين",
        revenue: "إجمالي الإيرادات",
        totalAiRuns: "إجمالي مهام الذكاء الاصطناعي"
      },
      users: {
        name: "الاسم",
        email: "البريد الإلكتروني",
        role: "الدور",
        aiCredits: "رصيد الذكاء الاصطناعي",
        verified: "موثق",
        joined: "تاريخ الانضمام"
      },
      iotMap: {
        loadingMap: "جاري تحميل خريطة الأسطول العالمي..."
      },
      actuators: {
        title: "وحدات التحكم بالنظام",
        registerNew: "تسجيل وحدة جديدة",
        cancel: "إلغاء",
        loading: "جاري تحميل وحدات التحكم...",
        noActuators: "لم يتم العثور على وحدات تحكم.",
        deleteConfirm: "هل أنت متأكد من حذف وحدة التحكم هذه؟",
        deleteSuccess: "تم حذف وحدة التحكم بنجاح.",
        createSuccess: "تم تسجيل وحدة التحكم بنجاح!",
        createFail: "فشل في تسجيل وحدة التحكم",
        selectUserAlert: "يرجى تحديد مستخدم لتعيين الوحدة له.",
        form: {
          actuatorName: "اسم وحدة التحكم",
          actuatorNamePlaceholder: "مثل: مضخة الحقل الرئيسية أ",
          controlCategory: "فئة التحكم",
          publishTopic: "مسار MQTT للإرسال (الأوامر)",
          publishTopicPlaceholder: "farm/pump_a/cmd",
          subscribeTopic: "مسار MQTT للاستقبال (الحالة)",
          subscribeTopicPlaceholder: "farm/pump_a/state",
          assignUser: "تعيين لمستخدم",
          selectUser: "-- اختر مستخدم --"
        },
        location: {
          mapPicker: "محدد الخريطة",
          manualEntry: "إدخال يدوي",
          mapInstruction: "انقر على الخريطة لتحديد موقع الوحدة.",
          lat: "خط العرض",
          lng: "خط الطول",
          locName: "اسم الموقع",
          locNamePlaceholder: "مثل: المنطقة أ",
          notSet: "لم يتم التحديد"
        },
        table: {
          id: "المعرف",
          name: "اسم الجهاز",
          type: "النوع",
          pubTopic: "مسار النشر",
          location: "الموقع",
          users: "المستخدمين"
        }
      }
    },

    // ─── Farm Accounting Module (AR) ─────────────────────────────────────
    accounting: {
      tabTitle: "حسابات المزرعة",
      netProfit: "صافي الربح",
      revenues: "الإيرادات",
      expenses: "المصروفات",
      yearLabel: "السنة المالية",
      addNode: "إضافة بند",
      addChild: "إضافة بند فرعي",
      deleteNode: "حذف",
      deleteConfirm: "حذف هذا البند وجميع البنود الفرعية؟",
      confirmYes: "نعم، احذف",
      confirmNo: "إلغاء",
      totalAmount: "المبلغ الإجمالي",
      unitPrice: "سعر الوحدة",
      quantity: "الكمية",
      frequency: "التكرار",
      categoryName: "اسم البند",
      categoryPlaceholder: "ابحث أو اكتب اسم البند...",
      addNewCategory: "إضافة \"{name}\" كبند جديد",
      noCategories: "لا توجد بنود مطابقة",
      saving: "جاري الحفظ...",
      saved: "تم الحفظ",
      saveError: "فشل الحفظ",
      currency: "جنيه",
      currencySymbol: "ج.م",
      positive: "ربح",
      negative: "خسارة",
      breakeven: "تعادل",
      expandDetails: "عرض التفاصيل",
      collapseDetails: "إخفاء التفاصيل",
      emptyTree: "ابدأ ببناء شجرتك المالية",
      emptyTreeDesc: "أضف بنود الإيرادات والمصروفات لتتبع ربحية مزرعتك.",
      backToApp: "رجوع",
      // Frequency options
      freq_daily: "يومي",
      freq_weekly: "أسبوعي",
      freq_monthly: "شهري",
      freq_seasonally: "موسمي",
      freq_yearly: "سنوي",
      // AI Advisor
      aiAdvisor: "المستشار المالي الذكي",
      aiAdvisorDesc: "احصل على تحليل ذكي لحسابات مزرعتك",
      aiAnalyze: "حلّل مزرعتي",
      aiAnalyzing: "جاري التحليل...",
      aiLength: "طول التقرير",
      aiShort: "مختصر (~100 كلمة)",
      aiMedium: "متوسط (~200 كلمة)",
      aiFull: "تقرير شامل",
      aiEmpty: "أضف بيانات مالية أولاً للحصول على تحليل ذكي.",
      aiError: "فشل التحليل الذكي. حاول مرة أخرى."
    }
  }
};

class TranslationService {
  constructor() {
    this.translations = TRANSLATIONS;
  }

  getTranslation(lang) {
    return this.translations[lang] || this.translations['en'];
  }

  async translateText(text, targetLang) {
    if (!text) return "";
    try {
      const chunks = text.split('\n');
      const translatedChunks = await Promise.all(chunks.map(async (chunk) => {
        if (!chunk.trim()) return chunk;
        const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl=${targetLang}&dt=t&q=${encodeURIComponent(chunk)}`;
        const res = await fetch(url);
        const json = await res.json();
        let translatedStr = json[0].map(item => item[0]).join('');
        translatedStr = translatedStr.replace(/\*\*\s*(.*?)\s*\*\*/g, '**$1**');
        return translatedStr;
      }));
      return translatedChunks.join('\n');
    } catch (error) {
      console.error("Translation error:", error);
      return text;
    }
  }
}

export default new TranslationService();
